// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2P1OZ","right":"styles_right__35x1_"};